<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="create_wrapper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :search="true"
        search_route="/clients"
        search_title="العملاء"
      />
      <!-- End Breadcrumb -->

      <div class="custom_card">
        <div class="card-header">
          <h4 class="card-title">{{ $t("edit") }}</h4>
        </div>

        <!-- ==== Start Form ==== -->
        <form @submit.prevent="validateCreateForm">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.username"
                  />
                  <label for="name_input" class="form-label">إسم العميل</label>
                </div>
              </div>

              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label file_input">
                  <span class="file_input_label">صورة العميل (إختياري)</span>
                  <label
                    for="file_input_1"
                    class="form-label"
                    v-if="!selectedFile.name"
                  ></label>
                  <label for="file_input_1" class="form-label" v-else>
                    {{ selectedFile.name }}
                  </label>
                  <input
                    type="file"
                    class="form-control"
                    id="file_input_1"
                    @change="handelSelectedFile"
                  />
                </div>
              </div>

              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.address"
                  />
                  <label for="name_input" class="form-label">{{
                    $t("forms.labels.address")
                  }}</label>
                </div>
              </div>

              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="email"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.email"
                  />
                  <label for="name_input" class="form-label">{{
                    $t("forms.labels.email")
                  }}</label>
                </div>
              </div>

              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.phone"
                  />
                  <label for="name_input" class="form-label">{{
                    $t("forms.labels.phone")
                  }}</label>
                </div>
              </div>

              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.fax"
                  />
                  <label for="name_input" class="form-label">{{
                    $t("forms.labels.fax")
                  }}</label>
                </div>
              </div>
              <!--START:: ASK TO OPEN ACCOUNT -->
              <div class="col-lg-12 py-0">
                <div class="sub_title">
                  <span>تفعيل البريد الإلكتروني</span>
                </div>
                <!-- START:: RADIO BUTTON INPUT -->
                <div class="input_wrapper radio_button_input">
                  <div class="flex_wrapper">
                    <v-radio-group v-model="radioButtonsValue">
                      <v-radio
                        label="نعم"
                        color="indigo lighten-2"
                        value="1"
                      ></v-radio>
                      <v-radio
                        label="لا"
                        color="indigo lighten-2"
                        value="0"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </div>
                <!-- END:: RADIO BUTTON INPUT -->
              </div>
            </div>
          </div>

          <div class="buttons_wrapper">
            <button
              class="button_style_1"
              :class="{buttonIndex: btnIsLoading}"
              :disabled="btnIsLoading"
            >
              تعديل
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </form>
        <!-- ==== End Form ==== -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  props: ["id"],

  data() {
    return {
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.clients.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // Date_menues
      dateMenu: false,
      debit_dateMenu: false,

      // search_users
      search_users: "",

      // START:: SELECTED FILE DATA
      selectedFile: {
        file: null,
        name: null,
        path: null,
      },
      // END:: SELECTED FILE DATA

      // ========== create_data
      data: {
        username: null,
        address: null,
        email: null,
        phone: null,
        fax: null,
      },

      // ========== Fixed_data
      users: [],
      radioButtonsValue: "1",
    };
  },

  watch: {
    [`search_users`](newVal) {
      this.get_filterd_users(newVal);
    },
  },

  methods: {
    // Get Data
    getData() {
      this.$axios({
        method: "GET",
        url: `categories`,
      }).then((res) => {
        this.categories = res.data.data;
      });
    },

    // get_filterd_users
    get_filterd_users(newVal) {
      if (newVal == "o") {
        this.users = ["omar"];
      } else {
        this.users = ["omar", "momen", "zoheir", "mahmoud", "essam", "diaa"];
      }
    },

    // START:: HANDLING SELECTED FILE METHOD
    handelSelectedFile(e) {
      this.selectedFile.file = e.target.files[0];
      this.selectedFile.name = e.target.files[0].name;
      this.selectedFile.path = URL.createObjectURL(e.target.files[0]);
    },
    // END:: HANDLING SELECTED FILE METHOD

    // Get Data
    getData() {
      this.$axios({
        method: "GET",
        url: "client/customer/" + this.id,
      }).then((res) => {
        this.data.username = res.data.data.name;
        this.data.address = res.data.data.address;
        if (res.data.data.fax) {
          this.data.fax = res.data.data.fax;
        }
        this.data.email = res.data.data.email;
        this.radioButtonsValue = res.data.data.has_email;
        this.data.phone = res.data.data.phone;
        this.selectedFile.name = res.data.data.image;
      });
    },

    // Validate Data
    validateCreateForm() {
      if (!this.btnIsLoading) {
        this.btnIsLoading = true;
        if (!this.data.username) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.name"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.address) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.address"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.email) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.email"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.phone) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.phone"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.radioButtonsValue) {
          this.$iziToast.error({
            timeout: 2000,
            message: "يرجي إختيار حالة البريد الإلكتروني",
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else {
          this.submitData();
          return;
        }
      }
    },

    // Submit Data
    submitData() {
      const submit_data = {
        name: this.data.username,
        address: this.data.address,
        fax: this.data.fax,
        email: this.data.email,
        phone: this.data.phone,
        image: this.selectedFile.file,
        has_email: this.radioButtonsValue,
      };
      if (!this.selectedFile.file) {
        delete submit_data.image;
      }
      if (!this.data.fax) {
        delete submit_data.fax;
      }
      this.$axios({
        method: "POST",
        url: "client/customer/update_customer/" + this.id,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "topRight",
          });
          this.$router.push({path: "/clients"});
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {
    this.getData();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("lock_and_deals")
    ) {
      this.$router.push("/");
    }
  },
};
</script>
